import type { TimeOffEntry } from '../../../api/timeOff';
import { isTimeOffEntryEnded } from './timeOffEntriesGridFilters';

export type TimeOffEntrySyncState = 'Waiting' | 'Error' | 'No targets' | 'Synced';

export function getTimeOffEntrySyncState(entry: TimeOffEntry): TimeOffEntrySyncState {
  const links = entry.calendarLinks ?? [];
  if (links.some((link) => link.isDirty)) return 'Waiting';
  if (links.some((link) => link.lastSyncResult?.startsWith('Error'))) return 'Error';
  if (links.length === 0) return 'No targets';
  return 'Synced';
}

/** Entries that need HR/admin follow-up (identity, sync, or missing calendars). */
export function hasTimeOffEntryIssue(entry: TimeOffEntry): boolean {
  if (entry.needsEmployeeIdentity) return true;
  return getTimeOffEntrySyncState(entry) !== 'Synced';
}

/**
 * Approved, fully ended PTO with clean sync state is historical — view only, no edit/cancel.
 */
export function isTimeOffEntryViewOnly(entry: TimeOffEntry, now = new Date()): boolean {
  return (
    entry.status === 'Approved' &&
    isTimeOffEntryEnded(entry, now) &&
    !hasTimeOffEntryIssue(entry)
  );
}

export function canMutateTimeOffEntry(entry: TimeOffEntry, now = new Date()): boolean {
  if (entry.status === 'Cancelled') return false;
  return !isTimeOffEntryViewOnly(entry, now);
}
